import { poizonChannelID as poizon_channel_id } from '@/utils/urlUtils/getQuery'
interface GetTrackParamsProps {
  globalConfig: {
    title: string
  }
  pageId: string
  spuId: string
  title: string
  index: number
  price: any
}

function getSingleTrackParamsWithoutInfoList(props: GetTrackParamsProps) {
  const { globalConfig, pageId, spuId, title, price, index } = props
  const url = `/router/sell/productDetail?spuId=${spuId}`
  const spu_price = price === 0 || price ? price : ''
  return {
    current_page: 82,
    block_type: 506,
    spu_price: spu_price,
    venue_id: pageId,
    venue_title: document.title,
    component_type_title: '最新出价组件',
    component_content_id: spuId,
    component_content_title: title,
    component_content_url: url,
    component_content_position: index + 1,
    component_content_request_id: '',
    poizon_component_type: 'poizon-latest-bid',
    poizon_channel_id,
    SK: window.dw.getSk(),
  }
}

function getCommonTrackParams(props: GetTrackParamsProps) {
  const { spuId, index, title, price } = props || {}
  const url = `/router/sell/productDetail?spuId=${spuId}`
  const spu_price = price === 0 || price ? price : ''
  return {
    ...getSingleTrackParamsWithoutInfoList(props),
    component_content_info_list: [
      JSON.stringify({
        component_content_title: title,
        component_content_id: spuId,
        component_content_url: url,
        component_content_position: index + 1,
        component_content_request_id: '',
        spu_price: spu_price,
        poizon_channel_id,
      }),
    ],
    SK: window.dw.getSk(),
  }
}

function createTrackConfig() {
  return {
    poizon_venue_component_content_exposure(platformName: string, dataset: DOMStringMap): any {
      if (platformName !== 'sensors') return
      const props: any = (this as any).props
      return getCommonTrackParams({
        globalConfig: props.globalConfig,
        pageId: props.pageId,
        spuId: props.spuId,
        title: props.title,
        price: props.price,
        index: props.index,
        SK: window.dw.getSk(),
      } as any)
    },
    poizon_venue_component_content_click(platformName: string, dataset: DOMStringMap): any {
      if (platformName !== 'sensors') return
      const props: any = (this as any).props
      return getCommonTrackParams({
        globalConfig: props.globalConfig,
        pageId: props.pageId,
        spuId: props.spuId,
        title: props.title,
        price: props.price,
        index: props.index,
        SK: window.dw.getSk(),
      } as any)
    },
  }
}

export { createTrackConfig }
